import React from "react"
import { navigate } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"
import { em } from "polished"

import Link from "../link"

export default function SearchResult({
  data,
  TitleStyled,
  LabelStyled,
  DescriptionStyled,
}) {
  const containerClick = () => navigate(data.path)

  return (
    <Container onClick={containerClick}>
      <Image>
        {data.image && <GatsbyImage image={data.image} alt={data.title} />}
      </Image>

      <Text>
        <Title>
          <TitleStyled as="span">
            <Link to={data.path}>{data.title}</Link>
          </TitleStyled>
        </Title>

        {data.description && (
          <Description as={DescriptionStyled}>{data.description}</Description>
        )}

        {data.label && (
          <Label>
            <LabelStyled as="span">{data.label}</LabelStyled>
          </Label>
        )}
      </Text>
    </Container>
  )
}

const Container = styled.article`
  padding: ${em(24)} ${em(20)};
  display: flex;
  align-items: flex-start;
  gap: ${em(16)};
  position: relative;
  border-radius: ${({ theme }) => theme.components?.searchResult?.br};
  background-color: ${({ theme }) =>
    theme.components?.searchResult?.backgroundColor || `#fff`};
  cursor: pointer;

  @media ${({ theme }) => theme.mq.smallDown} {
    padding: ${em(18)} ${em(14)};
  }
`

const Image = styled.figure`
  width: ${em(180)};
  flex-shrink: 0;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.components?.searchResult?.br};
  background-color: ${({ theme }) => theme.colors.imageBackground};

  @media ${({ theme }) => theme.mq.smallDown} {
    width: ${em(100)};
  }

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }
`

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(12)};

  @media ${({ theme }) => theme.mq.smallDown} {
    gap: ${em(6)};
  }
`

const Title = styled.h2`
  a {
    &:hover {
      opacity: 0.8;
    }
  }
`

const Description = styled.p`
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const Label = styled.div`
  padding: ${em(5)} ${em(18)};
  position: absolute;
  z-index: 10;
  top: 0;
  right: ${em(-20)};
  translate: 0 -50%;
  border-radius: ${({ theme }) => theme.components?.searchResult?.labelBr};
  color: ${({ theme }) => theme.components?.searchResult?.labelColor || `#fff`};
  background-color: ${({ theme }) =>
    theme.components?.searchResult?.labelBackgroundColor || `#000`};

  @media ${({ theme }) => theme.mq.smallDown} {
    font-size: ${em(13)};
    top: ${em(-5)};
    right: ${em(0)};
  }
`
